// Components==============
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import City from './components/City/City';
import Dessert from './components/Dessert/Dessert';
import Grass from './components/Grass/Grass';
import Space from './components/Space/Space';
import Water from './components/Water/Water';
// =========================

export default function Background({
    children,
    background,
}: {
    children: React.ReactNode;
    background: Background;
}) {
    const user = useSelector(
        (state: ReduxStore) => state?.authentication?.user
    );

    const useAnimations = user?.use_animations === 1;

    if (background === 'lake')
        return <Water useAnimations={useAnimations}>{children}</Water>;

    if (background === 'desert')
        return <Dessert useAnimations={useAnimations}>{children}</Dessert>;

    if (background === 'country') return <Grass>{children}</Grass>;

    if (background === 'space')
        return <Space useAnimations={useAnimations}>{children}</Space>;

    if (background === 'city') return <City>{children}</City>;

    return <></>;
}
